import React, { useEffect, useState, useContext } from "react";

import Input from "../../shared/components/Input";
import {
  VALIDATOR_VALIDATED,
  VALIDATOR_AUTOCOMPLETE,
  VALIDATOR_SELECT,
  VALIDATOR_NUMBER_ONLY,
} from "../../shared/util/validators";
import useForm from "../../shared/hooks/form-hooks";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";

import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import { useSnackbar } from "notistack";
import { AuthContext } from "../../context/AuthContext";
import { CircularProgress } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import AdapterJalaali from "@date-io/jalaali";
import FormControl from "@mui/material/FormControl";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import jMoment from "moment-jalaali";
import axios from "axios";
import FormControlLabel from "@mui/material/FormControlLabel";

import { useDispatch } from "react-redux";
import { CHANGE_ORDER } from "../../redux/types";

//defining instances
const UNITS = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "نامشخص",
  "فک بالا",
  "فک پایین",
];
const JAWS = ["یک فک", "دو فک"];

const ExitOrderForm = (props) => {
  const dispatch = useDispatch();
  const [orderData, setOrderData] = useState();
  const [process, setProcess] = useState([]);
  const [beforeProcesses, setBeforeProcesses] = useState([]);
  const [counter, setCounter] = useState(0);
  const [finished, setFinished] = useState(false);
  const [lastProcess, setLastProcess] = useState();
  const [isLoading, setIsLoading] = useState(true); //make it true when you are done
  const auth = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();

  const [exitDate, setExitDate] = useState(jMoment().startOf("day"));
  jMoment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });

  const orderId = props.orderId;
  //handling isfinished
  const handleFinished = (event) => {
    setFinished(event.target.checked);
  };

  //initilizing inputs
  const [formState, inputHandler, setFormData] = useForm(
    {
      unitCount: {
        value: "",
        isValid: false,
      },
      jawCount: {
        value: "",
        isValid: false,
      },
      upRight: {
        value: "",
        isValid: true,
      },
      upLeft: {
        value: "",
        isValid: true,
      },
      downRight: {
        value: "",
        isValid: true,
      },
      downLeft: {
        value: "",
        isValid: true,
      },
      exitDescription: {
        value: "",
        isValid: true,
      },
      tasksToDo: {
        value: [],
        isValid: true,
      },
    },
    false
  );

  //getting order data
  useEffect(() => {
    setIsLoading(true);
    axios
      .post(
        "/api/v1/laboratorys/get-order-process",
        {
          orderId: orderId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
        }
      )
      .then((response) => {
        setOrderData(response.data.data);
      })
      .catch((e) => {
        const messages =
          e.response.data.data.length > 0
            ? e.response.data.data
            : e.response.data.message.message;
        messages.map((message) => {
          enqueueSnackbar(message, { variant: "error" });
        });
      })
      .finally(() => setCounter(1));
  }, [orderId]);

  //getting order-type-processes
  useEffect(() => {
    if (counter == 1) {
      setProcess([]);
      orderData.orderTypeId &&
        axios
          .post(
            "/api/v1/laboratorys/get-orderType-process",
            {
              orderTypeId: orderData.orderTypeId,
            },
            {
              headers: {
                "Content-Type": "application/json",
                authorization: auth.token,
              },
            }
          )
          .then((response) => {
            setProcess(response.data.data);
            setCounter(2);
          })
          .catch((e) => {
            const messages =
              e.response.data.data.length > 0
                ? e.response.data.data
                : e.response.data.message.message;
            messages.map((message) => {
              enqueueSnackbar(message, { variant: "error" });
            });
            setCounter(2);
          });
    }
  }, [counter]);

  //getting previous order processes
  useEffect(() => {
    if (counter === 2) {
      setBeforeProcesses([]);
      orderData.process &&
        orderData.process.map(
          (p) =>
            p.endDate == null &&
            !beforeProcesses.includes(
              process.find((item) => item.id === p.orderTypeProcessId)
            ) &&
            setBeforeProcesses((prevState) => [
              ...prevState,
              process.find((item) => item.id === p.orderTypeProcessId),
            ])
        );
      setCounter(3);
    }
  }, [counter]);

  //getting field values
  useEffect(() => {
    if (counter === 3) {
      console.log(orderData);
      setFormData(
        {
          unitCount: {
            value: orderData.unitCount,
            isValid: true,
          },
          jawCount: {
            value: orderData.jawCount,
            isValid: true,
          },
          upRight: {
            value: orderData.upRight,
            isValid: true,
          },
          upLeft: {
            value: orderData.upLeft,
            isValid: true,
          },
          downRight: {
            value: orderData.downRight,
            isValid: true,
          },
          downLeft: {
            value: orderData.downLeft,
            isValid: true,
          },
          exitDescription: {
            value: "",
            isValid: true,
          },
          tasksToDo: {
            value: beforeProcesses,
            isValid: true,
          },
        },
        true
      );
      setCounter(4);
    }
  }, [counter]);

  //handling loading false
  useEffect(() => {
    counter === 4 && setIsLoading(false) && setCounter(0);
  }, [counter]);

  //getting the last process
  useEffect(() => {
    orderData && setLastProcess(...orderData.process.slice(-1));
  }, [orderData]);

  //submit order exit
  const exitOrderHandler = async (event) => {
    event.preventDefault();
    let processIds = [];
    for (let i = 0; i < formState.inputs.tasksToDo.value.length; i += 1) {
      processIds.push(formState.inputs.tasksToDo.value[i].id);
    }
    setIsLoading(true);

    axios
      .post(
        "/api/v1/laboratorys/create-exit-order",
        {
          orderId: orderId,
          isCkecked: finished,
          taskId: lastProcess.taskId,
          processIds: processIds,
          process: {
            unitCount: formState.inputs.unitCount.value,
            upRight: formState.inputs.upRight.value,
            upLeft: formState.inputs.upLeft.value,
            downLeft: formState.inputs.downLeft.value,
            downRight: formState.inputs.downRight.value,
            jawCount: formState.inputs.jawCount.value,
            startDate: lastProcess.startDate,
            endDate: new Date(exitDate).getTime().toString(),
            predictionDate: lastProcess.predictionDate,
            exitDescription: formState.inputs.exitDescription.value,
            entryDescription: lastProcess.entryDescription,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
        }
      )
      .then((response) => {
        enqueueSnackbar(response.data.message.message, {
          variant: "success",
        });
        dispatch({ type: CHANGE_ORDER, payload: null });
        setIsLoading(false);
      })
      .catch((e) => {
        const messages =
          e.response.data.data.length > 0
            ? e.response.data.data
            : e.response.data.message.message;
        messages.map((message) => {
          enqueueSnackbar(message, { variant: "error" });
        });
        setIsLoading(false);
      });
  };

  //test
  //   useEffect(() => {
  //     console.log(orderData);
  //   }, [orderData]);

  return (
    <>
      {isLoading ? (
        <CircularProgress color="primary" />
      ) : (
        <form onSubmit={exitOrderHandler}>
          <Grid container spacing={2}>
            <Grid
              md={4}
              xs={12}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {!orderData ? (
                <Chip
                  label="لطفا یک سفارش را انتخاب کنید."
                  color="error"
                  sx={{ p: 2 }}
                />
              ) : (
                <Chip
                  label={`___${orderData.boxNumber}___`}
                  color="success"
                  sx={{ p: 2 }}
                />
              )}
            </Grid>
            <Grid md={8} xs={12}>
              <Input
                id="tasksToDo"
                element="select"
                validators={[VALIDATOR_SELECT()]}
                errorText="لطفا عملیات را انتخاب کنید."
                multiline={true}
                onInput={inputHandler}
                initialValue={formState.inputs.tasksToDo.value}
                options={process}
                inputValid={formState.inputs.tasksToDo.isValid}
                label="انجام شده"
              />
            </Grid>
            <Grid md={12}>
              <hr />
            </Grid>
            <Grid md={6} xs={12}>
              <FormControl fullWidth>
                <LocalizationProvider dateAdapter={AdapterJalaali}>
                  <DatePicker
                    value={exitDate}
                    onChange={(date) => setExitDate(date)}
                    label="تاریخ ارسال"
                    disableMaskedInput
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        size={"medium"}
                        variant={"outlined"}
                      />
                    )}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>
            <Grid md={3} xs={6}>
              <Input
                id="unitCount"
                element="autoComplete"
                label="تعداد واحد"
                validators={[VALIDATOR_AUTOCOMPLETE()]}
                errorText="لطفا تعداد واحد را انتخاب کنید."
                onInput={inputHandler}
                options={UNITS}
                getOptionLabel={(unit) => unit}
                required={true}
                initialValue={formState.inputs.unitCount.value}
                inputValid={formState.inputs.unitCount.isValid}
              />
            </Grid>
            <Grid md={3} xs={6}>
              <Input
                id="jawCount"
                element="autoComplete"
                label="تعداد فک"
                validators={[VALIDATOR_AUTOCOMPLETE()]}
                errorText="لطفا تعداد فک را انتخاب کنید."
                onInput={inputHandler}
                options={JAWS}
                getOptionLabel={(jaw) => jaw}
                required={true}
                inputValid={formState.inputs.jawCount.isValid}
                initialValue={formState.inputs.jawCount.value}
              />
            </Grid>
            <Grid md={3} xs={6}>
              <Input
                id="upRight"
                element="number_only"
                label="شماره دندان (فک بالا راست)"
                validators={[VALIDATOR_VALIDATED(), VALIDATOR_NUMBER_ONLY()]}
                errorText="لطفا فقط عدد وارد کنید."
                onInput={inputHandler}
                initialValue={formState.inputs.upRight.value}
                inputValid={formState.inputs.upRight.isValid}
                inputProps={{ min: 1, max: 8 }}
              />
            </Grid>
            <Grid md={3} xs={6}>
              <Input
                id="upLeft"
                element="number_only"
                label="شماره دندان (فک بالا چپ)"
                validators={[VALIDATOR_VALIDATED(), VALIDATOR_NUMBER_ONLY()]}
                errorText="لطفا فقط عدد وارد کنید."
                onInput={inputHandler}
                initialValue={formState.inputs.upLeft.value}
                inputValid={formState.inputs.upLeft.isValid}
                inputProps={{ min: 1, max: 8 }}
              />
            </Grid>
            <Grid md={3} xs={6}>
              <Input
                id="downRight"
                element="number_only"
                label="شماره دندان (فک پایین راست)"
                validators={[VALIDATOR_VALIDATED(), VALIDATOR_NUMBER_ONLY()]}
                errorText="لطفا فقط عدد وارد کنید."
                onInput={inputHandler}
                initialValue={formState.inputs.downRight.value}
                inputValid={formState.inputs.downRight.isValid}
                inputProps={{ min: 1, max: 8 }}
              />
            </Grid>
            <Grid md={3} xs={6}>
              <Input
                id="downLeft"
                element="number_only"
                label="شماره دندان (فک پایین چپ)"
                validators={[VALIDATOR_VALIDATED(), VALIDATOR_NUMBER_ONLY()]}
                errorText="لطفا فقط عدد وارد کنید."
                onInput={inputHandler}
                initialValue={formState.inputs.downLeft.value}
                inputValid={formState.inputs.downLeft.isValid}
                inputProps={{ min: 1, max: 8 }}
              />
            </Grid>
            <Grid md={12} xs={12}>
              <Input
                id="exitDescription"
                element="input"
                label="توضیحات جهت ارسال"
                validators={[VALIDATOR_VALIDATED()]}
                multiline={true}
                onInput={inputHandler}
                inputValid={true}
                initialValue={formState.inputs.exitDescription.value}
              />
            </Grid>
            <Grid md={12} xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={finished}
                    onChange={handleFinished}
                    color="secondary"
                  />
                }
                label="اتمام کار"
                labelPlacement="end"
              />
            </Grid>
            <Grid xs={12} sm={12}>
              <Button
                type="submit"
                disabled={!formState.isValid || orderId === ""}
                fullWidth
                color="secondary"
                variant="contained"
              >
                ثبت ارسال
              </Button>
            </Grid>
          </Grid>
        </form>
      )}
    </>
  );
};

export default ExitOrderForm;
